export const PLAY_REQUESTS_API = 'v1/play-requests';

/** Max length for the free-text request/response messages. Enforced server-side
 *  on create + decline; also caps the client textareas. */
export const MAX_PLAY_REQUEST_MESSAGE_LENGTH = 1000;
/** Max concurrent outgoing PENDING requests a player may have. Enforced on create;
 *  the request modals read it to show what's left and block the form at zero. */
export const MAX_PENDING_PLAY_REQUESTS = 3;
// Pending requests one listing (game / availability) can hold before the host must respond.
export const MAX_PENDING_REQUESTS_PER_LISTING = 6;
export const getPlayRequestCancelApi = (playRequestId: string) =>
  `v1/play-requests/${playRequestId}/cancel`;
export const getPlayRequestLeaveApi = (playRequestId: string) =>
  `v1/play-requests/${playRequestId}/leave`;
export const getPlayRequestAcceptApi = (playRequestId: string) =>
  `v1/play-requests/${playRequestId}/accept`;
export const getPlayRequestDeclineApi = (playRequestId: string) =>
  `v1/play-requests/${playRequestId}/decline`;

export interface CreatePlayRequestPayload {
  eventId?: string; // game target (XOR availabilityId)
  availabilityId?: string; // player-availability target (XOR eventId)
  recipientUserId: string; // host user id (== user_profiles.id)
  requestMessage?: string;
  selectedVenueId?: string; // availability requests only
  selectedVenueIds?: string[]; // availability requests only -> play_request_venues
  selectedNeighborhoodIds?: string[]; // availability requests only -> play_request_neighborhoods
  availabilitySlotIds?: string[]; // availability requests only -> play_request_slots
  /** The one concrete time picked inside a weekly slot (availability requests). */
  requestedSlot?: RequestedSlotPayload;
}

export interface RequestedSlotPayload {
  availabilitySlotId: string;
  /** Calendar day at the venue, "YYYY-MM-DD". */
  date: string;
  /** Wall-clock at the venue, "HH:mm". */
  startTime: string;
  endTime: string;
}

// Failures on all four routes go through the shared response4xx/response500
// wrappers, which send `{ message, statusCode }` — not a body with an `error`
// field. So none of these carry one; read the error off the failed response.

export interface CreatePlayRequestResponse {
  success: boolean;
  playRequestId?: string;
  requestsRemaining?: number;
}

export interface CancelPlayRequestResponse {
  success: boolean;
}

export interface LeavePlayRequestResponse {
  success: boolean;
}

export interface DeclinePlayRequestPayload {
  responseMessage?: string;
}

export interface AcceptPlayRequestResponse {
  success: boolean;
  conversationId?: string;
}

export interface DeclinePlayRequestResponse {
  success: boolean;
}
